import React, { useEffect } from "react";
import Gradient from "./Gradient";
import serviceGif from "../Assets/giphy2.gif";
import "../Styles/ServiceSection.css";

const ServiceSection = () => {
  // Auto reload once on first load
  useEffect(() => {
    const hasReloaded = sessionStorage.getItem("hasReloaded");
    if (!hasReloaded) {
      sessionStorage.setItem("hasReloaded", "true");
      setTimeout(() => {
        window.location.reload();
      }, 200); // fraction of a second (200ms)
    }
  }, []);

  return (
    <div className="bg-c">
      {/* GradientBlinds Background */}
      <div
        style={{
          width: "100%",
          height: "100vh",
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 0,
        }}
      >
        <Gradient
          gradientColors={["#FF0000", "#007BFF"]}
          angle={23}
          noise={0}
          blindCount={16}
          blindMinWidth={60}
          spotlightRadius={0.5}
          spotlightSoftness={1}
          spotlightOpacity={1}
          mouseDampening={2}
          distortAmount={0}
          shineDirection="left"
          mixBlendMode="lighten"
        />
      </div>

      {/* Content Section */}
      <div className="services-container">
        {/* Left Side - Text */}
        <div className="services-text">
          <h2>Our Services</h2>
          <p>
            We provide world-class digital solutions ranging from web design and
            development to digital marketing and software solutions. Our
            approach ensures creativity, innovation, and performance at every
            step.
          </p>
        </div>

        {/* Right Side - GIF */}
        <div className="services-gif">
          <img src={serviceGif} alt="Services Animation" />
        </div>
      </div>
    </div>
  );
};

export default ServiceSection;
